import i18next from "i18next";
import { Validator, Success, Failure, ValidationError } from "@totalsoft/pure-validations";

export const validatePeriods = (minRange, maxRange) =>
  Validator(function validatePeriods(periods) {
    if (periods === null || periods === undefined || periods.length <= 0)
      return Failure(ValidationError(i18next.t("Validations.CheckCascoFlow.PeriodsMandatory")));
    return periods.some(x => x === null || x < minRange || x > maxRange)
      ? Failure(ValidationError(i18next.t("Validations.CheckCascoFlow.PeriodsRange", { minRange, maxRange })))
      : Success;
  });

export const validateInsurers = insurersList =>
  Validator(function validateInsurers(insurers) {
    if (insurers === null || insurers === undefined || insurers.length <= 0)
      return Failure(ValidationError(i18next.t("Validations.CheckCascoFlow.InsurersMandatory")));
    const containsAll = insurers.every(element => {
      return insurersList.includes(element);
    });
    return containsAll ? Success : Failure(ValidationError(i18next.t("Validations.CheckCascoFlow.Insurers")));
  });
